import { Component, Input, OnInit } from "@angular/core"
import { LearningObject } from "../../models/learningObject.model"
import { CHNode } from "../../models/node.model"
import { STATIC_IMAGES } from "../../models/constants"
import { AddOnViewService } from "../../services/add-on-view.service"

@Component({
    selector: "app-not-found-error",
    templateUrl: "./not-found-error.component.html",
    styleUrls: ["./not-found-error.component.scss"],
})
export class NotFoundErrorComponent implements OnInit {
    @Input() subjects: CHNode[]
    @Input() learningObjects: LearningObject[] = []
    image: string
    isAddOnView: boolean

    constructor(private addOnViewService: AddOnViewService) {
        this.image = STATIC_IMAGES.student_teacher_laptop
    }

    ngOnInit() {
        this.isAddOnView = this.addOnViewService.isAddonView
    }
}
